module.exports = __webpack_public_path__ + "static/media/404.e3ff156b.svg";